import { NgModule } from '@angular/core';
import { LoginComponent } from './page/login/login.component';
import { LoginFormComponent } from './components/login-form/login-form.component';
import { MemberLoginPanelComponent } from './components/member-login-panel/member-login-panel.component';

/**
 * AuthenticationUiModule — backward-compatibility barrel.
 * All components are now standalone. Import them directly in new code.
 * @deprecated Import standalone components directly instead.
 */
@NgModule({
  imports: [LoginComponent, LoginFormComponent, MemberLoginPanelComponent],
  exports: [LoginComponent, MemberLoginPanelComponent],
})
export class AuthenticationUiModule {}
